import { useState, useEffect } from "react";
import { connection } from "../../../utils/apiConnection.ts";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { BiEdit } from "react-icons/bi";
import { AiOutlineDelete } from "react-icons/ai";
import { TiTickOutline } from "react-icons/ti";
import toast from "react-hot-toast";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import ReactTooltip from "react-tooltip";
import Swal from "sweetalert2";
function OptionModal() {
  const [option, setOption] = useState({
    title: "",
    default_need_time: "",
    default_price: "",
  });
  const [optionList, setOptionList] = useState({});
  const [update, setUpdate] = useState(false);
  const [validatTitle, setValidatTile] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const changeHandler = (names, values) => {
    setOption((prev) => {
      return { ...prev, [names]: values };
    });
  };

  const editHandler = (index, type) => {
    if (type == "edit") {
      setOptionList((prev) => {
        let temp = [...prev];
        temp[index].editStatus = false;
        return temp;
      });
    } else if (type == "save") {
      setOptionList((prev) => {
        let temp = [...prev];
        temp[index].editStatus = true;
        return temp;
      });
    }

    // console.log(index);
  };
  const inputHandler = (names, value, index) => {
    switch (names) {
      case "title":
        setOptionList((prev) => {
          let temp = [...prev];
          temp[index].title = value;
          return temp;
        });
        break;
      case "default_need_time":
        // console.log("default_need_time");
        setOptionList((prev) => {
          let temp = [...prev];
          temp[index].default_need_time = value;
          return temp;
        });
        break;
      case "default_price":
        setOptionList((prev) => {
          let temp = [...prev];
          temp[index].default_price = value;
          return temp;
        });
        break;
    }
  };
  const saveOption = () => {
    setDisabledBtn(true);
    connection("api/Insert_AvailableOrderOption", option).then((data) => {
      if (data.status == true) {
        setDisabledBtn(false);
        toast.success("آپشن جدید با موفقیت ثبت شد.");
        setUpdate((prev) => !prev);
        setOption({
          title: "",
          default_need_time: "",
          default_price: "",
        });
      } else {
        setDisabledBtn(false);
        toast.error("مشکلی در ثبت آپشن جدید به وجود آمده است.");
      }
    });
  };
  const deleteOption = (id) => {
    Swal.fire({
      icon: "warning",
      title: "آیا از حذف این آپشن مطمئن هستید؟",
      showCancelButton: true,
      cancelButtonText: "انصراف",
      confirmButtonText: "حذف",
      cancelButtonColor: "#EF394E",
      confirmButtonColor: "#439B58",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        connection("/api/Update_AvailableOrderOption", {
          keyvalues: "option_status,-1",
          conditions: `id/=/${id}`,
        }).then((data) => {
          if (data.status == 1) {
            Swal.fire({
              title: "آپشن با موفقیت حذف شد.",
              showConfirmButton: false,
              timer: 2000,
            });
            setUpdate((prev) => !prev);
          } else {
            Swal.fire({
              title: "مشکلی در حذف آپشن بوجود آمده است.",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        });
      }
    });
  };
  useEffect(() => {
    connection("api/Find_AvailableOrderOption", {
      conditions: "option_status/=/0",
    }).then((data) => {
      setOptionList(() => {
        let temp = [...data.reverse()];
        console.log("data", data);
        console.log("data2", data.reverse());
        for (let i = 0; i < data.length; i++) {
          temp[i] = { ...temp[i], editStatus: true };
        }
        return temp;
      });
    });
  }, [update]);
  // console.log("optionList", optionList);
  return (
    <div
      class="modal fade"
      id="OptionModal"
      // data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">
              مدیریت آپشن ها
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div className="d-flex flex-wrap">
              <div className="px-1 col-12 col-sm-4">
                <label className="title">عنوان آپشن</label>
                <input
                  className="form-control"
                  value={option.title}
                  onChange={(e) => {
                    changeHandler("title", e.target.value);
                  }}
                ></input>
                <p
                  className="validText"
                  style={{ display: validatTitle ? "none" : "block" }}
                >
                  عنوان وارد نشده است.
                </p>
              </div>
              <div className="px-1 col-12 col-sm-4">
                <label className="title">
                  {" "}
                  زمان پیشفرض<span style={{ fontSize: "10px" }}>(دقیقه)</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={option.default_need_time / 60}
                  onChange={(e) => {
                    changeHandler(
                      "default_need_time",
                      removeCommas(e.target.value) * 60
                    );
                  }}
                ></input>
              </div>
              <div className="px-1 col-12 col-sm-4">
                <label className="title">
                  قیمت پیشفرض<span style={{ fontSize: "10px" }}>(تومان)</span>{" "}
                </label>
                <input
                  //   type="number"
                  className="form-control"
                  value={addCommas(option.default_price)}
                  onChange={(e) => {
                    changeHandler(
                      "default_price",
                      removeCommas(e.target.value)
                    );
                  }}
                ></input>
              </div>
            </div>
            <div className="d-flex justify-content-end my-2">
              <button
                className="btn btn-success"
                style={{ fontSize: "14px" }}
                onClick={() => {
                  if (option.title == "") {
                    setValidatTile((prev) => !prev);
                  } else {
                    saveOption();
                  }
                }}
                disabled={disabledBtn}
              >
                افزودن
              </button>
            </div>
            <>
              <div>
                {optionList.length > 0 &&
                  optionList
                    .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
                    .map((value, index) => {
                      return (
                        <div
                          className="d-flex flex-wrap border rounded my-3 option-list p-1"
                          style={{ backgroundColor: "rgb(227, 250, 234)" }}
                        >
                          <div className="text-center  my-1 col-12 col-lg-3 div px-2">
                            <div className="title border-bottom-green">
                              عنوان آپشن
                            </div>
                            <input
                              disabled={optionList[index].editStatus}
                              id={`editState${index}`}
                              className={`txt form-control text-center `}
                              defaultValue={value.title}
                              value={optionList[index].title}
                              onChange={(e) => {
                                inputHandler("title", e.target.value, index);
                              }}
                            ></input>

                            {/* <input
                          value={value.title}
                          className="form-control text-center"
                        ></input> */}
                          </div>
                          <div className="text-center  my-1 col-12 col-sm-6 col-lg-3 div px-2">
                            <div className="title border-bottom-green">
                              زمان پیشفرض
                              <span style={{ fontSize: "10px" }}>(دقیقه)</span>
                            </div>
                            <input
                              disabled={optionList[index].editStatus}
                              className="txt form-control text-center"
                              defaultValue={value.default_need_time / 60}
                              value={optionList[index].default_need_time / 60}
                              onChange={(e) => {
                                inputHandler(
                                  "default_need_time",
                                  e.target.value * 60,
                                  index
                                );
                              }}
                            ></input>

                            {/* <input
                          className="form-control text-center"
                          value={value.default_need_time}
                        ></input> */}
                          </div>
                          <div className="text-center  my-1 col-12 col-sm-6 col-lg-3 div px-2">
                            <div className="title border-bottom-green">
                              قیمت پیشفرض
                              <span style={{ fontSize: "10px" }}>(تومان)</span>
                            </div>
                            <input
                              disabled={optionList[index].editStatus}
                              className="txt form-control text-center"
                              value={addCommas(value.default_price)}
                              onChange={(e) => {
                                inputHandler(
                                  "default_price",
                                  removeCommas(e.target.value),
                                  index
                                );
                              }}
                            ></input>

                            {/* <input
                          className="form-control text-center"
                          value={addCommas(value.default_price)}
                        ></input> */}
                          </div>
                          <div className="text-center d-flex flex-column  my-1 col-12 col-sm-6 col-lg-3 div px-2">
                            <div className="title border-bottom-green">
                              عملیات{" "}
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                              {/* <BiEdit
                            style={{
                              display: optionList[index].editStatus
                                ? "block"
                                : "none",
                            }}
                            className="cursor-pointer"
                            onClick={() => {
                              editHandler(index, "edit");
                            }}
                          /> */}
                              {/* <TiTickOutline
                            className="cursor-pointer"
                            style={{
                              color: "green",
                              fontSize: "25px",
                              display: optionList[index].editStatus
                                ? "none"
                                : "block",
                            }}
                            onClick={() => {
                              editOption(index);
                            }}
                          /> */}
                              <div data-tip="حذف">
                                <AiOutlineDelete
                                  className="cursor-pointer mt-2"
                                  onClick={() => {
                                    deleteOption(value.id);
                                  }}
                                />
                                <ReactTooltip />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                <div className="d-flex ">
                  <Pagination
                    className="mx-auto my-3"
                    total={optionList.length}
                    pageSize={5}
                    current={currentPage}
                    onChange={(page) => {
                      setCurrentPage(page);
                    }}
                  ></Pagination>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OptionModal;
